const sampleTypesSelectSelector = '.js-sample-types-select',
  dataImageAttributeAttribute = 'data-image-id',
  swiperSelectorBase = '.js-swiper',
  swiperSelectorDataAttribute = 'data-sample-types-hook',
  sampleTypesSelectSwiperIdAttribute = 'data-swiper-id',
  imgSwiperIndexAttribute = 'data-swiper-index';

const sampleTypesSelect = () => {
  const sampleTypesSelects = document.querySelectorAll(
    sampleTypesSelectSelector
  );

  [...sampleTypesSelects].forEach(sampleTypesSelect => {
    sampleTypesSelect.addEventListener('change', event => {
      const select = event.target;

      if (select.selectedIndex === -1) return;

      const selectedOption = select.options[select.selectedIndex],
        swiperElement = document.querySelector(
          `${swiperSelectorBase}[${swiperSelectorDataAttribute}="${select.getAttribute(
            sampleTypesSelectSwiperIdAttribute
          )}"]`
        ),
        swiper = swiperElement.swiper,
        imgSelector = `img[${dataImageAttributeAttribute}="${selectedOption.getAttribute(
          dataImageAttributeAttribute
        )}"]`,
        swiperImg = swiperElement.querySelector(imgSelector);

      if (!swiperImg) return;

      const imgIndex = Number(swiperImg.getAttribute(imgSwiperIndexAttribute));

      /*
        slideTo is supposed to take a third argument that determines whether
        callbacks are run (true means they are run and is the default). It
        doesn't appear to be working, so here we are with a stupid hack.
        There's probably just something I'm missing but I obviously don't know
        what that is.
      */
      swiper.params.stupidHack = false;
      swiper.slideTo(imgIndex, swiper.params.speed, false);
      swiper.params.stupidHack = true;
    });
  });
};

export default {
  init: sampleTypesSelect,
};
